import { customerTags, opportunityTags, tags } from '../tag'
import { describeTable } from './describeTable'

describeTable(tags, {
  description:
    'The shared vocabulary of sales labels applied to opportunities and customers (opportunity_tags, customer_tags). Free-form, staff-created; name is unique. A tag is a boolean — no value, no timestamp, no author.',
  columns: {
    name: "Label text as shown in the ERP, e.g. 'ei tulisijoja'.",
    color: 'Mantine colour name for the badge; display only.',
  },
})

describeTable(opportunityTags, {
  description:
    'Which tags are on which opportunity. One row per (opportunity, tag); hard-deleted, no timestamps, so tag history cannot be reconstructed.',
})

describeTable(customerTags, {
  description:
    "Which tags are on which customer — sales-owned labels such as structural facts ('ei tulisijoja' = no fireplaces, so no nuohous). One row per (customer, tag); hard-deleted, no timestamps.",
})
